import React from 'react';

const VolunteerSection = () => {
  return (
    <section className="relative text-white py-12 bg-black/70">
      {/* Overlay */}
      <div className="absolute inset-0 bg-black opacity-50"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          {/* Image Section */}
          <div className="flex">
            <div
              className="h-96 w-full rounded-lg bg-cover bg-center"
              style={{ backgroundImage: "url('/images/bg_4.png')" }}
            ></div>
          </div>

          {/* Text Content */}
          <div>
            <h3 className="text-2xl font-bold mb-4">Youth Empowerment</h3>
            <p className="mb-6">
              As an NGO, Ceyone Foundations focuses on youth empowerment.
              Having a clear vision, mission, and objectives is essential to achieving impactful social change.
            </p>
            <a
              href="/service/youth-empowerment"
              className="inline-block px-5 py-3 border border-white rounded hover:bg-white hover:text-black transition"
            >
              Read More
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VolunteerSection;
